import { getAllDocsByTask } from "@/api/tasks/getAllDocsByTask";
import { useQuery } from "@tanstack/react-query";

export const useGetAllDocsByTask = (taskId: string) => {

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["allDocs", taskId],
    queryFn: () => getAllDocsByTask(taskId),
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
  })

  const docs = data?.data || [];

  return { docs, isLoading, error, refetch };
};